export const VERSION_TUTTIENGLISH = "3.0.3";